import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import styles from "./Sidebar.module.css";
import { useTheme } from "../../../contexts/ThemeContext";

const Sidebar = () => {
  const { theme } = useTheme();

  const linkStyle =
    theme === "light" ? styles.linkStyle_light : styles.linkStyle_dark;

  return (
    <aside bg={theme === "light" ? "light" : "dark"} className={styles.sidebar}>
      <Nav className="flex-column">
        <Nav.Link as={NavLink} to="/users" className={linkStyle}>
          Пользователи
        </Nav.Link>
        <Nav.Link as={NavLink} to="/messages" className={linkStyle}>
          Сообщения
        </Nav.Link>
        <Nav.Link as={NavLink} to="/complaints" className={linkStyle}>
          Жалобы
        </Nav.Link>
        <Nav.Link as={NavLink} to="/analytics" className={linkStyle}>
          Аналитика
        </Nav.Link>
        <Nav.Link as={NavLink} to="/verification" className={linkStyle}>
          Верификация
        </Nav.Link>
        <Nav.Link as={NavLink} to="/broadcast" className={linkStyle}>
          Массовые уведомления
        </Nav.Link>
      </Nav>
    </aside>
  );
};

export default Sidebar;
